<template>
    <div>
        <nav-secondary :navOptions="navOptions"></nav-secondary>
        <router-view class="flex-page-content flex-container view"/>
    </div>
</template>

<script>
import NavSecondary from '@/components/NavSecondary'

export default {
    components: { NavSecondary, },
    props: ['client', ],
    data() {
        return {
            navOptions: [
                {'text': 'Forms', 'value': 'admin-pdf-forms-forms'},
                {'text': 'Questions', 'value': 'admin-pdf-forms-questions'},
                {'text': 'Selection Tester', 'value': 'admin-pdf-forms-tester'},
                {'text': 'State Rules Review', 'value': 'admin-pdf-forms-rules'},
                {'text': 'State Rules Test', 'value': 'admin-pdf-forms-rules-test'},
            ]
        }
    },
    mounted() {
        const routes = this.navOptions.map(x => x.value)
        if (routes.indexOf(this.$route.name) < 0) {
            this.$router.replace({name: routes[0]})
        }
    },
}
</script>
